var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { default as AntInput } from 'antd/lib/input';
import { default as AntTextArea } from 'antd/lib/input/TextArea';
import { default as AntIcon } from 'antd/lib/icon';
import { basicPropTypes, controlPropTypes } from '../component-props';
import { services } from '@comall-backend-builder/core';
/**
 * 文本输入框
 */

var Textbox = function (_super) {
  __extends(Textbox, _super);

  function Textbox(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  Textbox.prototype.handleChange = function (e) {
    var _a = this.props,
        name = _a.name,
        onChange = _a.onChange;
    var value = e.target.value;

    if (onChange) {
      onChange(value, name);
    }
  };

  Textbox.prototype.shouldComponentUpdate = function (nextProps) {
    return !isEqual(this.props, nextProps);
  };

  Textbox.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        name = _a.name,
        value = _a.value,
        _b = _a.placeholder,
        placeholder = _b === void 0 ? services.language.getText('common.pleaseInput') : _b,
        disabled = _a.disabled,
        maxLength = _a.maxLength,
        type = _a.type,
        size = _a.size,
        autoSize = _a.autoSize,
        addonBefore = _a.addonBefore,
        addonAfter = _a.addonAfter,
        prefix = _a.prefix,
        suffix = _a.suffix,
        prefixIcon = _a.prefixIcon,
        suffixIcon = _a.suffixIcon;
    var inputProps = {
      // basicPropTypes
      className: className,
      style: style,
      // controlPropTypes
      name: name,
      value: value,
      size: size,
      placeholder: placeholder,
      disabled: disabled,
      maxLength: maxLength,
      onChange: this.handleChange
    };

    if (type === 'textarea') {
      inputProps.autoSize = autoSize;
      return React.createElement(AntTextArea, __assign({}, inputProps));
    } else {
      Object.assign(inputProps, {
        type: type,
        addonBefore: addonBefore,
        addonAfter: addonAfter,
        prefix: prefixIcon ? React.createElement(AntIcon, {
          type: prefixIcon
        }) : prefix,
        suffix: suffixIcon ? React.createElement(AntIcon, {
          type: suffixIcon
        }) : suffix
      });
      return React.createElement(AntInput, __assign({}, inputProps));
    }
  };

  Textbox.defaultProps = {
    type: 'text'
  };
  Textbox.propTypes = __assign(__assign(__assign({}, basicPropTypes), controlPropTypes), {
    // 文本框类型
    type: PropTypes.oneOf(['text', 'password', 'textarea']),
    // 自适应内容高度，只对 type="textarea" 有效，可设置为 true|false 或对象：{ minRows: 2, maxRows: 6 }
    autoSize: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
      minRows: PropTypes.number,
      maxRows: PropTypes.number
    })])
  });
  return Textbox;
}(Component);

export { Textbox };